"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (type) { return function (_a) {
    var theme = _a.theme;
    return "border-radius: " + theme.buttons[type].borderRadius + ";";
}; });
